import { LazyImport, LazyModule } from 'owa-bundling';

export const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "getVendorListJson", webpackPrefetch: true */ './lazyIndex')
);

export let lazyGdprVendorList = new LazyImport(lazyModule, m => m.getVendorListJson);
